
            import { welcomePageInit } from '/public/js/welcome/welcomepage.js'
            welcomePageInit()
        